<template>
  <div>
    <b-card>
      <b-card-header class="text-center"> Arquivos </b-card-header>
      <b-overlay :show="carregandoListaArquivos">
        <b-table
          striped
          hover
          stacked="md"
          show-empty
          :items="aposentadoria.ArquivoAposentadoria"
          :fields="computedFields"
        >
          <template #empty>
            <span>Não foram encontrados resultados.</span>
          </template>

          <template #cell(TamArquivo)="data">
            {{ Math.round(data.item.TamArquivo / 1024) }} KB
          </template>

          <template #cell(acao)="data">
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="baixarArquivo(data.item.NmArquivo, data.item.IdArquivo)"
              ><font-awesome-icon icon="circle-down" />
            </b-button>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>

<script lang="ts">
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { Component, Vue, Watch } from "vue-property-decorator";
import { PropType } from "vue";
import { Aposentadoria } from "@/types/aposentadoria/aposentadoria";
import { store } from "@/store";
import { TableField } from "@/types/table-field";
import aposentadoriaService from "@/services/atos-pessoal/aposentadoriaService";
const CompProps = Vue.extend({
  name: "AbaArquivosAposentadoria",
  props: {
    aposentadoria: {
      type: Object as PropType<Aposentadoria>,
      required: true,
    },
  },
});

@Component
export default class AbaArquivosAposentadoria extends mixins(
  UtilsTS,
  CompProps
) {
  //Variáveis para overlays
  carregandoListaArquivos = false;

  //computeds
  get computedFields(): TableField[] {
    const fields: TableField[] = [
      {
        key: "NmArquivo",
        label: "Nome do arquivo",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
      {
        key: "TamArquivo",
        label: "Tamanho",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
      {
        key: "IdTipoArquivoNavigation.DeTipoArquivo",
        label: "Tipo de arquivo",
        tdClass: "quebrarPorPalavraHard, text-center",
        thClass: "text-center",
      },
      {
        key: "acao",
        tdClass: "text-center",
        label: "",
      },
    ];
    return fields;
  }

  async baixarArquivo(nomeArquivo: string, idArquivo: number) {
    try {
      this.carregandoListaArquivos = true;
      const response = await aposentadoriaService.baixarArquivo(idArquivo);
      this.download(nomeArquivo, response.data);
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.carregandoListaArquivos = false;
    }
  }

  download(filename, content): void {
    var element = document.createElement("a");
    element.setAttribute("href", URL.createObjectURL(content));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
</script>
